{
  "male": [
    "Kestrel",
    "Pell",
    "Quill",
    "Corvo",
    "Rook",
    "Halcyon",
    "Aial",
    "Aur",
    "Deekek",
    "Errk",
    "Heehk",
    "Kleeck",
    "Oorr",
    "Ouss",
    "Quaf",
    "Quierk",
    "Urreek",
    "Zeed",
    "Akkra",
    "Arrik",
    "Brakk",
    "Corvan",
    "Corrick",
    "Craik",
    "Crake",
    "Dunlin",
    "Eyas",
    "Falk",
    "Garrow",
    "Gyre",
    "Harrier",
    "Hawkin",
    "Kaark",
    "Karrow",
    "Kek",
    "Kettrik",
    "Kraal",
    "Krekk",
    "Krett",
    "Kurrik",
    "Osprey",
    "Ptarmin",
    "Rukka",
    "Skarr",
    "Skaw",
    "Strix",
    "Talon",
    "Tarsel",
    "Tiercel",
    "Torrik",
    "Varek",
    "Vulcar",
    "Weklak",
    "Yark",
    "Zekk",
    "Agrak",
    "Alcedo",
    "Anhinga",
    "Aquilo",
    "Ardeo",
    "Bittern",
    "Brant",
    "Buteo",
    "Caracar",
    "Chakk",
    "Chukar",
    "Cirrus",
    "Condor",
    "Coot",
    "Corax",
    "Corbin",
    "Crex",
    "Curlew",
    "Dikkop",
    "Drongo",
    "Egret",
    "Ekko",
    "Falco",
    "Fulmar",
    "Gannet",
    "Garganey",
    "Godwit",
    "Grackle",
    "Gruss",
    "Hobby",
    "Hoopoe",
    "Huginn",
    "Ibis",
    "Ikaro",
    "Jaeger",
    "Kakko",
    "Kiko",
    "Kite",
    "Kokako",
    "Kraak",
    "Kree",
    "Lanner",
    "Loon",
    "Muninn",
    "Nighthawk",
    "Ortolan",
    "Ouzel",
    "Petrel",
    "Pharo",
    "Pipit",
    "Plover",
    "Pukeko",
    "Quetzal",
    "Raven",
    "Razorbill",
    "Ruff",
    "Saker",
    "Scoter",
    "Shrike",
    "Skua",
    "Snipe",
    "Sora",
    "Stilt",
    "Stork",
    "Swift",
    "Tattler",
    "Teal",
    "Tern",
    "Tokk",
    "Turnstone",
    "Vireo",
    "Whimbrel",
    "Wigeon",
    "Yaffle",
    "Aarok",
    "Bakka",
    "Chirrup",
    "Dakka",
    "Errik",
    "Fwip",
    "Gakk",
    "Hrok",
    "Ikk",
    "Jikko",
    "Krik",
    "Lokk",
    "Mikko",
    "Nakk",
    "Okka",
    "Prukk",
    "Qwik",
    "Rikkit",
    "Sikk",
    "Tchak",
    "Ukka",
    "Vikko",
    "Wikk",
    "Yikka",
    "Zikka",
    "Akio",
    "Hayabusa",
    "Ikaru",
    "Kaito",
    "Karasu",
    "Kuro",
    "Taka",
    "Tengo",
    "Tsubasa",
    "Washi",
    "Hakon",
    "Hrafn",
    "Orn",
    "Valr",
    "Skeggi",
    "Ari",
    "Arnulf",
    "Bjarnhard",
    "Egil",
    "Grim",
    "Hroald",
    "Kraki",
    "Sigvald",
    "Ulf",
    "Arkak",
    "Belgarr",
    "Chiruk",
    "Dravik",
    "Errekk",
    "Ferrik",
    "Gruukk",
    "Harrock",
    "Iskarr",
    "Jorrik",
    "Kavrik",
    "Larrock",
    "Morrik",
    "Norrack",
    "Orrin",
    "Prakk",
    "Quorrik",
    "Rakkar",
    "Skrell",
    "Tharrik",
    "Vorrak",
    "Wrekk",
    "Yarrow",
    "Zakkar",
    "Ash",
    "Bramble",
    "Cinder",
    "Clink",
    "Cloud",
    "Dart",
    "Drift",
    "Dusk",
    "Flint",
    "Gale",
    "Gust",
    "Hollow",
    "Jett",
    "Knap",
    "Moss",
    "Pebble",
    "Rattle",
    "Rust",
    "Scree",
    "Slate",
    "Smoke",
    "Soot",
    "Spar",
    "Storm",
    "Thistle",
    "Thorn",
    "Twig",
    "Whistle",
    "Wick",
    "Wisp",
    "Cobb",
    "Fennick",
    "Ivo",
    "Kip",
    "Nib",
    "Oswin",
    "Arrokh",
    "Cawdor",
    "Craw",
    "Dwerrk",
    "Feathro",
    "Grackell",
    "Hrrak",
    "Ixtli",
    "Kekkor",
    "Kikkor",
    "Krrah",
    "Ozzik",
    "Quarrk",
    "Rrakk",
    "Skirr",
    "Tchikk",
    "Torrock",
    "Vikkar",
    "Waukk",
    "Xolotl",
    "Yekk",
    "Zarrk",
    "Aetos",
    "Boreas",
    "Caelus",
    "Euros",
    "Notos",
    "Zephyr",
    "Kaladar",
    "Ornis",
    "Pteros",
    "Aquila",
    "Cyrrus",
    "Strigo",
    "Ulula",
    "Corvinus",
    "Pyrrho",
    "Tyto",
    "Asio",
    "Bubo",
    "Glaucus",
    "Nyctos",
    "Aakhar",
    "Brisk",
    "Cawl",
    "Corrin",
    "Dorrak",
    "Fledge",
    "Hackle",
    "Kirrik",
    "Pinion",
    "Remex",
    "Scarp",
    "Skyrrik",
    "Stoop",
    "Tarrok",
    "Vane",
    "Kaw",
    "Krakko",
    "Gharr",
    "Torvik",
    "Brannock"
  ],
  "female": [
    "Tirra",
    "Skree",
    "Aerie",
    "Lark",
    "Pippit",
    "Sorrel",
    "Kitti",
    "Wynn",
    "Kreeya",
    "Tik'ka",
    "Aera",
    "Ikki",
    "Salleek",
    "Aeri",
    "Avia",
    "Avocet",
    "Bree",
    "Brillee",
    "Cheela",
    "Chiri",
    "Chirra",
    "Cirri",
    "Coo",
    "Dove",
    "Finch",
    "Firecrest",
    "Fleet",
    "Hirundo",
    "Ibisa",
    "Jacana",
    "Kakariki",
    "Kiri",
    "Kittiwake",
    "Linnet",
    "Lory",
    "Lyra",
    "Merla",
    "Nightjar",
    "Oriole",
    "Paloma",
    "Pipi",
    "Piri",
    "Pirra",
    "Plume",
    "Prinia",
    "Quail",
    "Robin",
    "Rosella",
    "Seren",
    "Siskin",
    "Skylark",
    "Sparrow",
    "Starling",
    "Sunbird",
    "Swallow",
    "Swan",
    "Tanager",
    "Tirrit",
    "Titmouse",
    "Trillia",
    "Tui",
    "Twyla",
    "Veery",
    "Wren",
    "Zirri",
    "Alauda",
    "Amsel",
    "Bulbula",
    "Calandra",
    "Columba",
    "Corella",
    "Cotinga",
    "Cygna",
    "Ember",
    "Ennit",
    "Feather",
    "Galah",
    "Halcyone",
    "Ilaria",
    "Jaya",
    "Juniper",
    "Kaka",
    "Kereru",
    "Kiora",
    "Koel",
    "Laysan",
    "Liri",
    "Lumi",
    "Mallee",
    "Manakin",
    "Mavis",
    "Minah",
    "Mira",
    "Myna",
    "Nene",
    "Ninni",
    "Ortalis",
    "Pewit",
    "Philomel",
    "Phoebe",
    "Pica",
    "Pira",
    "Pyrrha",
    "Quilla",
    "Rhea",
    "Riri",
    "Sabine",
    "Selah",
    "Shama",
    "Skye",
    "Syrinx",
    "Tealy",
    "Tiri",
    "Torri",
    "Ula",
    "Vesper",
    "Whydah",
    "Willa",
    "Wira",
    "Yuhina",
    "Zosta",
    "Hibari",
    "Kotori",
    "Suzume",
    "Tsubame",
    "Uguisu",
    "Brina",
    "Eala",
    "Niamh",
    "Breeze",
    "Dawn",
    "Flutter",
    "Glimmer",
    "Hush",
    "Petal",
    "Rain",
    "Sprig",
    "Sunrise",
    "Thrum",
    "Trill",
    "Twilight",
    "Whisper",
    "Willow",
    "Aiya",
    "Cheep",
    "Chrrip",
    "Ehri",
    "Fiila",
    "Heekra",
    "Ilikki",
    "Ireeka",
    "Keeli",
    "Kiree",
    "Kliss",
    "Leeka",
    "Liree",
    "Meeka",
    "Neera",
    "Peela",
    "Pheeli",
    "Preeta",
    "Qiri",
    "Reeka",
    "Seeya",
    "Shree",
    "Skeeli",
    "Tchirra",
    "Teeka",
    "Tilli",
    "Treeli",
    "Tweeli",
    "Weeka",
    "Yiira",
    "Ziree",
    "Hattie",
    "Mabel",
    "Nell",
    "Tess",
    "Aethra",
    "Boreala",
    "Celaeno",
    "Dione",
    "Halia",
    "Iris",
    "Ocypete",
    "Podarge",
    "Thaumia",
    "Aello",
    "Calla",
    "Halcya",
    "Nephele",
    "Larissa",
    "Tytonia",
    "Nocturna",
    "Corvina",
    "Picata",
    "Merula",
    "Alcyone",
    "Ardea",
    "Egretta",
    "Ciconia",
    "Pavona",
    "Regula",
    "Anthea",
    "Hirunda",
    "Riparia",
    "Coracia",
    "Upupa",
    "Meropa",
    "Oriola",
    "Sturna",
    "Lanya",
    "Ficedula",
    "Luscinia",
    "Phylla",
    "Parula",
    "Cardella",
    "Aleeri",
    "Amirra",
    "Asheel",
    "Avaree",
    "Beeva",
    "Bellerra",
    "Briri",
    "Callee",
    "Chiralee",
    "Cirrila",
    "Deela",
    "Dirrin",
    "Eelia",
    "Ellira",
    "Esree",
    "Faliri",
    "Feela",
    "Firri",
    "Gilleri",
    "Haleel",
    "Heeva",
    "Ileera",
    "Irrilee",
    "Jilli",
    "Kaliree",
    "Keera",
    "Kiraa",
    "Kirralee",
    "Kittrin",
    "Laleeta",
    "Leerin",
    "Lilit",
    "Lirrit",
    "Lissee",
    "Maleeta",
    "Mirri",
    "Mirrila",
    "Nalee",
    "Nirrin",
    "Ooli",
    "Orree",
    "Palee",
    "Pella",
    "Pilarra",
    "Pirrina",
    "Reesa",
    "Rilli",
    "Sareel",
    "Sheela",
    "Sirri",
    "Tallee",
    "Tari",
    "Teerin",
    "Tirrilee",
    "Trilli",
    "Twirra",
    "Valee",
    "Veela",
    "Virri",
    "Weela",
    "Wirrin",
    "Yalee",
    "Yirri",
    "Zarra",
    "Zeela",
    "Zirrila",
    "Kiskadee",
    "Weebill",
    "Silvereye",
    "Pardalote",
    "Fantail",
    "Bellbird",
    "Thornbill",
    "Fairywren",
    "Chickadee",
    "Wagtail",
    "Goldcrest",
    "Redstart",
    "Stonechat",
    "Bunting",
    "Serin",
    "Twite",
    "Lapwing"
  ],
  "family": [
    "Swiftwing",
    "Stormfeather",
    "Highnest",
    "Cloudrider",
    "Duskplume",
    "Windcall",
    "Reedwader",
    "Brightbeak",
    "Thermalgold",
    "Cliffperch",
    "Ashfeather",
    "Ashwing",
    "Amberquill",
    "Amberplume",
    "Bluecrest",
    "Bluefeather",
    "Blackpinion",
    "Blackquill",
    "Brackenroost",
    "Brambleperch",
    "Briarnest",
    "Brightcrest",
    "Brightfeather",
    "Brightwing",
    "Bronzebeak",
    "Broadwing",
    "Cairnroost",
    "Cinderwing",
    "Cliffnest",
    "Cliffsoar",
    "Cloudbeak",
    "Cloudcrest",
    "Cloudfeather",
    "Cloudperch",
    "Cloudsoar",
    "Copperbeak",
    "Copperwing",
    "Coppercrest",
    "Crestfall",
    "Crookbeak",
    "Dawnfeather",
    "Dawnflight",
    "Dawnplume",
    "Dawntrill",
    "Dewfeather",
    "Downfeather",
    "Driftfeather",
    "Driftplume",
    "Duskfeather",
    "Duskflight",
    "Dusktrill",
    "Eaglecrest",
    "Eastwind",
    "Eddywing",
    "Emberbeak",
    "Emberplume",
    "Eveningtrill",
    "Fairwing",
    "Fallowfeather",
    "Farflight",
    "Farsoar",
    "Farwind",
    "Fernnest",
    "Fernroost",
    "Flintbeak",
    "Flintclaw",
    "Foamwing",
    "Frostbeak",
    "Frostfeather",
    "Frostwing",
    "Galebeak",
    "Galefeather",
    "Galerider",
    "Galewing",
    "Gildedwing",
    "Goldbeak",
    "Goldfeather",
    "Goldtalon",
    "Greycrest",
    "Greyfeather",
    "Greywing",
    "Gustfeather",
    "Gustrider",
    "Hailwing",
    "Hawkcrest",
    "Hazelnest",
    "Heathroost",
    "Highcrest",
    "Highflight",
    "Highperch",
    "Highsoar",
    "Highwind",
    "Hillnest",
    "Hollowbeak",
    "Hollowroost",
    "Hookbeak",
    "Hushwing",
    "Ironbeak",
    "Irontalon",
    "Ivorybeak",
    "Larchroost",
    "Longbeak",
    "Longflight",
    "Longwing",
    "Marshwader",
    "Mistfeather",
    "Mistwing",
    "Moonfeather",
    "Moonwing",
    "Mossnest",
    "Mudwader",
    "Nightfeather",
    "Nightwing",
    "Northwind",
    "Oakroost",
    "Pinecrest",
    "Pineroost",
    "Plumewood",
    "Quickbeak",
    "Quickfeather",
    "Quickwing",
    "Quillwright",
    "Rainfeather",
    "Rainwing",
    "Redbeak",
    "Redcrest",
    "Redwing",
    "Reedfeather",
    "Reednest",
    "Ridgeperch",
    "Ridgesoar",
    "Rimefeather",
    "Rivercrest",
    "Rockperch",
    "Rookwood",
    "Rushnest",
    "Russetwing",
    "Sandwader",
    "Scarletcrest",
    "Shadowwing",
    "Sharpbeak",
    "Sharptalon",
    "Shellbeak",
    "Silverbeak",
    "Silvercrest",
    "Silverwing",
    "Skycrest",
    "Skydancer",
    "Skyfeather",
    "Skyperch",
    "Skysoar",
    "Slatewing",
    "Snowfeather",
    "Snowplume",
    "Softfeather",
    "Songcrest",
    "Southwind",
    "Sparkwing",
    "Spirewing",
    "Starcrest",
    "Starfeather",
    "Starwing",
    "Steepwing",
    "Stillwing",
    "Stoneperch",
    "Stormbeak",
    "Stormcrest",
    "Stormwing",
    "Sunbeak",
    "Suncrest",
    "Sunfeather",
    "Sunwing",
    "Swiftbeak",
    "Swiftcrest",
    "Swiftplume",
    "Talonmark",
    "Thistlenest",
    "Thornperch",
    "Thundercrest",
    "Thunderwing",
    "Tidewader",
    "Tidewing",
    "Twigweaver",
    "Valecrest",
    "Velvetwing",
    "Westwind",
    "Whitecrest",
    "Whitefeather",
    "Whitewing",
    "Willowroost",
    "Windcrest",
    "Windfeather",
    "Windrider",
    "Windsoar",
    "Windwhistle",
    "Wingfeather",
    "Wintercrest",
    "Wisproost",
    "Yellowbeak",
    "Yewroost",
    "Acornnest",
    "Alderperch",
    "Applebough",
    "Aspenroost",
    "Barleynest",
    "Barkwhistle",
    "Beechbough",
    "Birchroost",
    "Burrowbeak",
    "Cedarcrest",
    "Chestnutwing",
    "Cloverbeak",
    "Cottonplume",
    "Elmroost",
    "Fennest",
    "Flaxnest",
    "Gorsenest",
    "Hazelperch",
    "Heatherwing",
    "Hollyroost",
    "Juniperwing",
    "Mapleperch",
    "Meadowsong",
    "Mossbeak",
    "Nettlenest",
    "Pebblebeak",
    "Rowanbough",
    "Rushwhistle",
    "Sedgewing",
    "Sorrelnest",
    "Spruceperch",
    "Sweetbriar",
    "Teaselnest",
    "Thatchroost",
    "Thistledew",
    "Twinebeak",
    "Wheatwing",
    "Wildthatch",
    "Cloudreach",
    "Dawnreach",
    "Gyrewind",
    "Highcloud",
    "Highgyre",
    "Loftwing",
    "Skyreach",
    "Spiralwing",
    "Stormreach",
    "Sunreach",
    "Thermalrider",
    "Windgyre",
    "Wingreach",
    "Clattercall",
    "Clickbeak",
    "Hootwell",
    "Kitterbeak",
    "Knockbeak",
    "Peepwhistle",
    "Pipesong",
    "Rattlebeak",
    "Ringcall",
    "Rustlewing",
    "Shrillwind",
    "Singsong",
    "Trillwhistle",
    "Warblewood",
    "Whistledown",
    "Whistlewing",
    "Wingbeat",
    "Ak'kaar",
    "Chirrek",
    "Ekkari",
    "Errikal",
    "Hikkari",
    "Ikkarrak",
    "Kaark'tal",
    "Keerik",
    "Kiirra",
    "Kikkaro",
    "Kleekar",
    "Krakkath",
    "Kreekal",
    "Kurrikka",
    "Okkarri",
    "Orrikal",
    "Prekkari",
    "Qirrak",
    "Rrakkath",
    "Skarrik",
    "Skreeval",
    "Tchekkari",
    "Tikkari",
    "Torrikka",
    "Urrekka",
    "Vekkari",
    "Wekkarr",
    "Yikkara",
    "Zekkarri",
    "Aerieborn",
    "Aeriewatch",
    "Cliffborn",
    "Cragroost",
    "Eyriefall",
    "Eyriehold",
    "Highaerie",
    "Nestborn",
    "Nestguard",
    "Nestkeeper",
    "Nestwatch",
    "Perchwarden",
    "Roostkeeper",
    "Roostwarden",
    "Branchwarden",
    "Cragnest",
    "Crownperch",
    "Cliffwarden",
    "Spirenest",
    "Eaglesreach",
    "Falconcrest",
    "Featherhold",
    "Flockhold",
    "Flockmother",
    "Flockwarden",
    "Hawkmoor",
    "Heronwade",
    "Kestrelcliff",
    "Kitehollow",
    "Larkhill",
    "Larkmoor",
    "Magpiehill",
    "Owlhollow",
    "Owlmere",
    "Plovermarsh",
    "Ravencliff",
    "Ravenmoor",
    "Ravenroost",
    "Rookhollow",
    "Rooksnest",
    "Sparrowhall",
    "Starlingmere",
    "Storkwade",
    "Swanmere",
    "Thrushwood",
    "Warblerwood",
    "Wrenhollow",
    "Crowfoot",
    "Crowhill",
    "Gullcliff",
    "Ternshore",
    "Petrelreef",
    "Puffinrock",
    "Ospreyfall",
    "Kitewind",
    "Swiftmere",
    "Martinwall",
    "Jaybrook",
    "Linnetfield",
    "Siskinwood",
    "Robinhedge",
    "Wagtailmere",
    "Larksong",
    "Wrensong",
    "Thrushsong",
    "Blackbird",
    "Goldfinch",
    "Greenfinch",
    "Redpoll",
    "Featherfall",
    "Featherdown",
    "Featherlight",
    "Feathersong",
    "Feathertrail",
    "Plumefall",
    "Plumeheart",
    "Quillfeather",
    "Quillstone",
    "Pinionstone",
    "Pinionfall",
    "Pinionheart",
    "Talonheart",
    "Talonstrike",
    "Talonwood",
    "Beakstone",
    "Beakwood",
    "Wingheart",
    "Wingstone",
    "Wingwhistle",
    "Crestwood",
    "Crestwell",
    "Roosthall",
    "Rooststone",
    "Nestwell",
    "Nestfield",
    "Nestbrook",
    "Downheart",
    "Fledgewood",
    "Glidemere",
    "Soarfield",
    "Altoroost",
    "Mistralwing",
    "Aquilon",
    "Rocwing",
    "Huginsson",
    "Muninsdottir",
    "Ornsdottir",
    "Arnsson",
    "Hrafnsson",
    "Valsson",
    "Ternisson",
    "Kestrelson",
    "MacRaven",
    "O'Rook",
    "Amberwing",
    "Ashcrest",
    "Barrowroost",
    "Bellwing",
    "Birchwhistle",
    "Bluequill",
    "Briskwing",
    "Brookwader",
    "Calmwind",
    "Chalkcliff",
    "Cindercrest",
    "Clearcall",
    "Cliffcall",
    "Coldwind",
    "Coolfeather",
    "Cragwing",
    "Crimsonwing",
    "Daggerbeak",
    "Darkpinion",
    "Deepnest",
    "Dimwing",
    "Dovecote",
    "Dunewader",
    "Duskcall",
    "Echocrest",
    "Elmwhistle",
    "Embercrest",
    "Fairfeather",
    "Fenwader",
    "Fleetwing",
    "Foxfeather",
    "Gladeroost",
    "Glintfeather",
    "Gloamwing",
    "Graycall",
    "Greenquill",
    "Gullwing",
    "Harecrest",
    "Hazewing",
    "Hearthnest",
    "Hillcall",
    "Hollowcall",
    "Hornbeak",
    "Inkfeather",
    "Inkwing",
    "Jadecrest",
    "Keelbeak",
    "Kelpwader",
    "Lakewader",
    "Lanternwing",
    "Lightquill",
    "Lochwader",
    "Lowroost",
    "Marshcall",
    "Mirewing",
    "Mistcall",
    "Moorcall",
    "Nightcall",
    "Oakfeather",
    "Ochrewing",
    "Palecrest",
    "Peakroost",
    "Pearlwing",
    "Pinewhistle",
    "Quietwing",
    "Raincall",
    "Ravenquill",
    "Reedcall",
    "Rimecrest",
    "Rivercall",
    "Rubycrest",
    "Saffronwing",
    "Saltwing",
    "Scrubroost",
    "Seacrest",
    "Shalewing",
    "Shorewader",
    "Silkfeather",
    "Skipwing",
    "Smokefeather",
    "Spraywing",
    "Squallwing",
    "Stillcall",
    "Stormcall",
    "Sunquill",
    "Tallroost",
    "Tanagerwing",
    "Tawnyfeather",
    "Thicketroost"
  ],
  "gendered": {
    "male": [
      "Huginsson",
      "Arnsson",
      "Hrafnsson",
      "Valsson",
      "Ternisson"
    ],
    "female": [
      "Flockmother",
      "Muninsdottir",
      "Ornsdottir"
    ]
  }
}
